import React, { useMemo, useState } from 'react';
import { RotateCcw } from 'react-feather';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';

import { useUnit, useUnits } from 'hooks/units/index';
import { useUser } from 'hooks/index';
import useI18n from 'hooks/use-i18n';

import {
  COURSE_STATUS,
  UNIT_STATUS,
  UNIT_STATUS_TOOL_TIP,
  UNIT_TYPE,
  USER_ROLES,
} from 'constants/constants';
import {
  refreshUnitAsync,
  resetUnitAsync,
  setUnitLoading,
} from 'store/units/index';
import { getSelectedCentre } from 'store/master';
import { getNextUnit, handleToastError } from 'helpers/index';
import { getUnitRoute } from 'helpers/unitRoute';

import ButtonDropdownCustom from 'components/CustomButton/ButtonDropdownCustom';
import ButtonNotPassed from './ButtonNotPassed';
import { getColor, getColorText } from 'store/settings';
import reportApi from 'api/reportApi';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';

const ButtonCompleted = (props) => {
  const { preventContinue } = props;
  const i18n = useI18n();
  const dispatch = useDispatch();
  const unitSelected = useUnit();
  const units = useUnits();
  const { roles } = useUser();
  const router = useRouter();
  const user = useUser();
  const { query } = router;
  const selectedCentre = useSelector(getSelectedCentre);
  const [isLoading, setIsLoading] = useState(false);
  const config = unitSelected?.config;

  const isFailed = unitSelected?.results?.some(
    (result) =>
      result?.status === UNIT_STATUS.FAILED ||
      result?.status === UNIT_STATUS.NOT_ATTEMPT,
  );
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const resultStatus =
    unitSelected?.status === UNIT_STATUS.PENDING
      ? unitSelected?.oldStatus
      : unitSelected?.status;

  const nextUnit = useMemo(
    () => getNextUnit(units, unitSelected?._id),
    [units, unitSelected],
  );
  const isNextUnit = !!(nextUnit?.unit ?? nextUnit?._id);

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const renderTextCompleted = () => {
    if (unitSelected?.status === UNIT_STATUS.COMPLETED) {
      return UNIT_STATUS_TOOL_TIP.COMPLETED;
    }
    clearInterval(props.setIntervalId);
    for (let i = 0; i < 1000; i++) {
      window.clearInterval(i);
    }
    return '';
  };

  const renderTextContinue = () => {
    if (nextUnit?._id) {
      return " Let's continue";
    }
    return '';
  };

  const handleRouteContinue = async () => {
    setIsLoading(true);
    await router.push(getUnitRoute(query?.slug, nextUnit));
  };

  const handleResetUnit = async () => {
    if (!config?.repetitions) {
      return;
    }
    try {
      let param = {};
      if (selectedCentre?._id) {
        param.centreId = selectedCentre?._id;
      }
      if (
        selectedCentre?.reviewContent ||
        selectedCentre?.reviewContent === undefined
      ) {
        param.reviewContent = true;
      }
      setIsLoading(true);
      await dispatch(resetUnitAsync(unitSelected._id, query?.slug, param));
      window.location.reload();
    } catch (e) {
      setIsLoading(false);
      handleToastError(e, i18n);
    }
  };

  async function testRest() {
    try {
      let params = {
        id: router?.query?.unitId,
        userId: user?._id,
      };
      const res = await reportApi.getTestReset(params);
      showToastSuccess('Reattempt allowed successfully!');
      dispatch(setUnitLoading(true));
      dispatch(refreshUnitAsync(query?.unitId));
    } catch (error) {
      handleToastError(error);
    }
  }

  if (isFailed) {
    return (
      <ButtonNotPassed
        onReAttempt={testRest}
        onResetUnit={handleResetUnit}
        onRouteContinue={handleRouteContinue}
        isLoading={isLoading}
        isNextUnit={isNextUnit}
      />
    );
  }

  if (
    (roles?.includes(USER_ROLES.SUPER_ADMIN) ||
      roles?.includes(USER_ROLES.ADMIN) ||
      roles?.includes(USER_ROLES.INSTRUCTOR)) &&
    !preventContinue
  ) {
    return (
      renderTextCompleted() !== '' && (
        <ButtonDropdownCustom
          action={handleRouteContinue}
          title={`${renderTextCompleted()}${renderTextContinue()}`}
          actions={[
            {
              text: 'Resubmit',
              action: handleResetUnit,
              iconLeft: <RotateCcw size={15} className="mr-05" />,
            },
          ]}
          disabled={isLoading || isDisabled}
          disabledBtn={!isNextUnit}
          disabledMenu={!config?.repetitions}
        />
      )
    );
  }

  return (
    <button
      onClick={handleRouteContinue}
      disabled={isLoading || !isNextUnit || preventContinue || isDisabled}
      className="btn-bg-color"
      // color={preventContinue ? 'secondary' : 'primary'}
      style={{
        backgroundColor: `${colorStatus}`,
        color: `${colorTextStatus}`,
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'white';
        e.target.style.borderColor = colorStatus;
        e.target.style.color = colorStatus;
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = colorStatus;
        e.target.style.color = colorTextStatus;
      }}
    >
      {renderTextCompleted()}
      {!preventContinue && renderTextContinue()}
    </button>
  );
};

export default ButtonCompleted;
